import { FC } from "react";

interface LetterIconSVGProps {
    className?: string;
}

const LetterIconSVG: FC<LetterIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M29.3307 9.33203L17.3707 16.932C16.9591 17.1899 16.4832 17.3267 15.9974 17.3267C15.5116 17.3267 15.0357 17.1899 14.6241 16.932L2.66406 9.33203M5.33073 5.33203H26.6641C28.1368 5.33203 29.3307 6.52594 29.3307 7.9987V23.9987C29.3307 25.4715 28.1368 26.6654 26.6641 26.6654H5.33073C3.85797 26.6654 2.66406 25.4715 2.66406 23.9987V7.9987C2.66406 6.52594 3.85797 5.33203 5.33073 5.33203Z"
                stroke="currentColor"
                strokeWidth="2.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default LetterIconSVG;
